import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import LoaderSimple from "../../../../general/loader";
import { Button } from "@ts-digital/vrc";
import FormBuilderAsk from "../../formBuilder";
import { saveCommunityTemplate } from "../../../../../store/actions/ask";
import { useSaveDotsFeedbackToast } from "../../../../../customHooks";
import { getInitials } from "../../../../../libs/utils";

const DetailTemplatePage = ({ templateDetails, isLoading, templateId, authorId }) => {

  const dispatch = useDispatch();
  const saveCommunityTemplateState = useSelector(state => state.ask.saveCommunityTemplateState);
  const [isFromSaveDots, setIsFromSaveDots] = useState(false);
  const payload = templateDetails?.payload;
  const decodedPayload = atob(payload);
  const parsedTemplateDetails = JSON.parse(decodedPayload);

  useSaveDotsFeedbackToast(
    saveCommunityTemplateState, isFromSaveDots, true
  );

  const saveDots = () => {
    dispatch(saveCommunityTemplate(templateId));
    setIsFromSaveDots(true);
  };

  return (
    <div className="detailTemplatePageContainer">
      {!isLoading ?
        (<>
          <div className="detailTemplatePageButtons">
					  <div className="priceContainer">
					    <div className="authorInfoContainer">
					      <div className="roundAuthor">
					        <span>
					          {templateDetails.authorName
					            ? getInitials(templateDetails.authorName)
					            : "N/A"}{" "}
					        </span>
					      </div>
					      <h5 className="templateAuthor">{templateDetails.authorName}</h5>
					    </div>
					    <h5 className="templatePrice">{templateDetails.price ? templateDetails.price : <FormattedMessage id="ask.pages.edit.communityTemplates.templatePriceFree" />}</h5>
					  </div>
					  <div className="buttonsContainer">
					    {saveCommunityTemplateState.isSavingCommunityTemplateDetails ?
					      <LoaderSimple />
					      :
					      <Button
					        className="gs-settings-popover-apply detailTemplatePageButton"
					        onClick={() => saveDots()}
					      >
					        <FormattedMessage id="ask.pages.edit.communityTemplates.detailTemplatePageButton" />
					      </Button>
					    }
					    {/* <Link to="/">
							<button className="detailTemplatePageLinkToAuthorTemplates">
								<FormattedMessage id="ask.pages.edit.communityTemplates.detailTemplatePageGoToAuthorTemplates" />
							</button>
							</Link> */}
					  </div>
          </div>
          <div className="formBuilderDotsContainer">
					  <FormBuilderAsk
					    bodyRequest={parsedTemplateDetails}
					    preview={true}
					    isDots={true}
					    onFormChange={() => { }}
					    isDotsPreview={true}
					  />
          </div>
        </>
        ) : (LoaderSimple)
      }
    </div>
  );
};

export default DetailTemplatePage;